import React, { useEffect, useState } from "react";
import { useStore } from "@nanostores/react";
import { $isOrderSuccessful, $limdisc } from "../../utils/store";
import FlipClockCountdown from '@leenguyen/react-flip-clock-countdown';
import '@leenguyen/react-flip-clock-countdown/dist/index.css';
import { __t } from "../../utils/translate";
import Container from "./container";
import { Link } from "gatsby";

type DiscountProps = {
    children?: React.ReactNode;
    data?: unknown[];
};

const Discount: React.FC<React.PropsWithChildren<DiscountProps>> = ({ children, data }) => {

    const gotOrder = useStore($isOrderSuccessful);
    const limdisc = useStore($limdisc);
    const [orderTime, setOrderTime] = useState<Date | null>(null);
    const [visibleDiscount, setVisibleDiscount] = useState<boolean>(false);

    useEffect(() => {
        if (!visibleDiscount && limdisc) {
            setVisibleDiscount(true);
            setOrderTime(new Date(limdisc * 1000));
        }
    }, [gotOrder, limdisc]);

    return (
        <>
            {visibleDiscount && (
                <div className="h-22 bg-dark-blu z-30 w-full py-3 md:py-2 border-b-[7px] border-b-[#e27745]">
                    <Container className="!max-w-[1024px]">
                        <div className="flex flex-col xl:flex-row justify-between items-center w-full gap-5">
                            <div className="flex flex-col xl:flex-row gap-2 md:gap-1 xl:gap-3 items-center">
                                <span className="text-white text-2xl md:text-3xl text-center xl:text-left">
                                    {__t("Any product with a 20% discount")}
                                </span>
                                <Link
                                    className={`bg-button-accent-color text-white font-bold px-5 py-[10px] uppercase rounded`}
                                    to="/shop"
                                >
                                    {__t("Shop")}
                                </Link>
                            </div>
                            <div className="flex flex-col sm:flex-row gap-2 items-center">
                                <span className="sm:max-w-[150px] text-white text-base-16-strong md:text-xl">{__t("Your discount expires in:")}</span>
                                {orderTime &&
                                    <FlipClockCountdown
                                        to={orderTime.getTime()}
                                        className='flip-clock'
                                        renderMap={[false, true, true, true]}
                                        showLabels={false}
                                        separatorStyle={{ color: '#e27745' }}
                                        digitBlockStyle={{
                                            fontWeight: 700,
                                            backgroundColor: '#e27745',
                                            borderRadius: 0,
                                        }}
                                    />}
                            </div>
                        </div>
                    </Container>
                </div>
            )}
        </>
    );
};

export default Discount;
